export default __webpack_public_path__ + "static/media/oral-4.5e00103a.png";